var _rect, _rect2, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCheck(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 1,
    width: 15,
    height: 15,
    rx: 1.5,
    fill: "#4A4A68"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 1,
    width: 15,
    height: 15,
    rx: 1.5,
    stroke: "#4A4A68"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.4735 5.30657C12.4115 5.24409 12.3378 5.19449 12.2565 5.16065C12.1753 5.1268 12.0881 5.10938 12.0001 5.10938C11.9121 5.10938 11.825 5.1268 11.7437 5.16065C11.6625 5.19449 11.5888 5.24409 11.5268 5.30657L6.56013 10.2799L4.47346 8.18657C4.40911 8.12441 4.33315 8.07554 4.24992 8.04274C4.16668 8.00993 4.0778 7.99385 3.98834 7.99539C3.89889 7.99694 3.81062 8.01609 3.72857 8.05176C3.64651 8.08742 3.57229 8.13889 3.51013 8.20324C3.44797 8.26759 3.39909 8.34355 3.36629 8.42679C3.33349 8.51002 3.3174 8.59891 3.31895 8.68836C3.3205 8.77781 3.33965 8.86609 3.37531 8.94814C3.41097 9.03019 3.46245 9.10441 3.5268 9.16657L6.0868 11.7266C6.14877 11.7891 6.22251 11.8387 6.30375 11.8725C6.38498 11.9063 6.47212 11.9238 6.56013 11.9238C6.64814 11.9238 6.73527 11.9063 6.81651 11.8725C6.89775 11.8387 6.97149 11.7891 7.03346 11.7266L12.4735 6.28657C12.5411 6.22415 12.5951 6.14838 12.6321 6.06404C12.669 5.97971 12.6881 5.88864 12.6881 5.79657C12.6881 5.70451 12.669 5.61344 12.6321 5.5291C12.5951 5.44477 12.5411 5.369 12.4735 5.30657Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheck);
export default __webpack_public_path__ + "static/media/check.9499abd699c807f9c28b0a0e7dcaf1c0.svg";
export { ForwardRef as ReactComponent };